// IMPORT IKON
import {
  FaTelegram ,
  FaCss3Alt,
  FaHtml5,
  FaBootstrap,
  FaNodeJs,
  FaGitAlt,
} from "react-icons/fa";
import { SiJavascript, SiCanva, SiNextdotjs } from "react-icons/si";
import { BsInstagram, BsGithub, BsWhatsapp } from "react-icons/bs";

import Proyek1 from "../assets/Proyek1.png";
import Proyek2 from "../assets/Proyek2.png";
import Proyek3 from "../assets/Proyek3.png";

export const Keahlian = [

  {
    id: 1,
    nama: "Javascript",
    ikon: <SiJavascript />,
  },
  {
    id: 3,
    nama: "Node JS",
    ikon: <FaNodeJs />,
  },
  {
    id: 4,
    nama: "Next JS",
    ikon: <SiNextdotjs />,
  },
  {
    id: 5,
    nama: "HTML",
    ikon: <FaHtml5 />,
  },
  {
    id: 6,
    nama: "CSS",
    ikon: <FaCss3Alt />,
  },
  {
    id: 7,
    nama: "Bootstrap",
    ikon: <FaBootstrap />,
  },
  {
    id: 9,
    nama: "Git",
    ikon: <FaGitAlt />,
  },
  {
    id: 9,
    nama: "Canva",
    ikon: <SiCanva />,
  }
];

export const DetailProyek = [
  {
    id: 0,
    nama_proyek: "Swisstronik",
    deskripsi_proyek:
      "As a Swisstronik Ambassador, I am responsible for building and engaging the community, driving awareness about Swisstronik's innovative blockchain solutions, and supporting users during the Testnet phases. My role includes organizing community activities, providing feedback on new features, and promoting the platform across various channels to ensure a successful Testnet 2.0 Phase 2 launch. Through active participation, I help foster growth and collaboration within the Swisstronik ecosystem, contributing to the project's overall success and the advancement of decentralized technologies.",
    alat: ["Ambassador"],
    gambar: Proyek1,
    link: "https://twitter.com/swisstronik",
    kebalikan: false,
  },
  {
    id: 1,
    nama_proyek: "Socrates",
    deskripsi_proyek:
      "As an Ambassador for Project Socrates, my role is to actively promote and raise awareness of the project within the Web3 and blockchain community. I engage with community members, provide support during Testnet phases, and contribute to the growth of the platform by sharing educational content, such as tutorials and articles. Additionally, I gather feedback from users to relay to the development team, ensuring that the platform evolves based on community input and needs. Through these efforts, I help foster adoption and ensure the success of Project Socrates.",
    alat: ["Ambassador"],
    gambar: Proyek2,
    link: "https://twitter.com/Socrates_global",
    kebalikan: true,
  },
  {
    id: 2,
    nama_proyek: "Dymension",
    deskripsi_proyek:
      "As a Validator for Dymension, I was responsible for securing the network by validating transactions and maintaining the integrity of the blockchain. My role included participating in consensus mechanisms, ensuring uptime and performance of the node, and actively contributing to the decentralized nature of the network. Additionally, I provided feedback on network performance and participated in testnet phases to support the growth and optimization of the Dymension ecosystem.",
    alat: ["Validator rollapps"],
    gambar: Proyek3,
    link: "https://twitter.com/dymension",
    kebalikan: false,
  },
];

export const NavigasiTautan = [
  {
    id: 0,
    nama: "Home",
    tautan: "Beranda",
  },
  {
    id: 1,
    nama: "My Skills",
    tautan: "Keahlian",
  },
  {
    id: 2,
    nama: "My Experince",
    tautan: "Proyek",
  },
  {
    id: 3,
    nama: "Contact me",
    tautan: "Kontak",
  },
];

export const SosialTautan = [
  {
    id: 0,
    tautan: "https://www.instagram.com/riky_m.a/",
    ikon: <BsInstagram />,
  },
  {
    id: 1,
    tautan: "https://github.com/Riky-Testnet",
    ikon: <BsGithub />,
  },
  {
    id: 1,
    tautan: "https://t.me/riky702",
    ikon: <FaTelegram />,
  },
];
